module.exports = __webpack_public_path__ + "media/src/images/page01_sub_001_zu0101-9e449ebb60e352694faabb5fba87f292.png";